import styled from 'styled-components';

export const SLanguageSelectPosition = styled.div`
  position: absolute;
  bottom: 20%;
`;
